import { render, staticRenderFns } from "./AgentSetting.vue?vue&type=template&id=9ab0204a&scoped=true&"
import script from "./AgentSetting.vue?vue&type=script&lang=js&"
export * from "./AgentSetting.vue?vue&type=script&lang=js&"
import style0 from "./AgentSetting.vue?vue&type=style&index=0&id=9ab0204a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab0204a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
  VTextField,
})
